<template>
    <div>
        <!-- Page Title -->
        <h2 class="page-title-bar">
      <i class="ico ico-powerrail"></i>{{ $t("Power Rails") }}
    </h2>
        <!-- Search Area -->
        <!-- <div class="searchArea"> -->

            <!-- Power Rail Input -->
            <!-- <v-text-field style="max-width: 20%;" v-model="search.code" @keyup.enter="togetPowerRailList(1)" :label="$t('Power Rail ID')"
                :placeholder="$t('Power Rail ID')" class="form-input ml-3" outlined dense hide-details
                clearable></v-text-field> -->
            <!-- Network Select -->
            <!-- <v-select style="max-width: 20%;" v-model="search.state" :label="$t('Status')" :placeholder="$t('Select status')"
                :items="searchOptions.network" item-text="text" item-value="abbr" class="form-select ml-3" outlined
                dense hide-details clearable></v-select> -->
            <!-- Search Button -->
            <!-- <v-btn @click="() => {this.selected=[];togetPowerRailList(1)}" class="btn type-search ml-3" text>
                {{ $t('Search') }}
            </v-btn>
        </div> -->
        <div class="searchArea">
              <v-select
        style="max-width: 20%;"
        v-model="search.type"
        :items="searchTypes"
        label="Search By"
        class="form-select ml-3"
        outlined
        dense
        @change="InputReset()"
        hide-details
      ></v-select>
         <v-text-field v-if="search.type === 'powerRail'" style="max-width: 20%;" v-model="search.code" @keyup.enter="togetPowerRailList(1)" :label="$t('Power Rail ID')"
                :placeholder="$t('Power Rail ID')" class="form-input ml-3" outlined dense hide-details
                clearable></v-text-field>
            <v-select v-if="search.type === 'powerRail'" style="max-width: 20%;" v-model="search.state" :label="$t('Status')" :placeholder="$t('Select status')"
                :items="searchOptions.network" item-text="text" item-value="abbr" class="form-select ml-3" outlined
                dense hide-details clearable></v-select>
            <div v-if="search.type === 'shelf'" class="d-flex">
                <v-text-field style="max-width: 30%;" v-model="search.shelfId" @keyup.enter="togetPowerRailList(1)" :label="$t('Shelf ID')"
                :placeholder="$t('Shelf ID')" class="form-input ml-3" outlined dense hide-details
                clearable></v-text-field>
                 <v-text-field style="max-width: 30%;" v-model="search.shelfFloor" @keyup.enter="togetPowerRailList(1)" :label="$t('Shelf Floor')"
                :placeholder="$t('Shelf Floor')" class="form-input ml-3" outlined dense hide-details
                clearable></v-text-field>
                 <v-text-field style="max-width: 30%;" v-model="search.shelfRow" @keyup.enter="togetPowerRailList(1)" :label="$t('Shelf Row')"
                :placeholder="$t('Shelf Row')" class="form-input ml-3" outlined dense hide-details
                clearable></v-text-field>
            </div>
                <v-select v-if="search.type === 'battery'" style="max-width: 20%;" v-model="search.battery" :label="$t('Battery')" :placeholder="$t('Select Battery status')"
                :items="searchOptionsBattery.options" item-text="text" item-value="abbr" class="form-select ml-3" outlined
                dense hide-details clearable></v-select>
                 <v-select v-if="search.type === 'signal'" style="max-width: 20%;" v-model="search.signal" :label="$t('Signal')" :placeholder="$t('Select Signal status')"
                :items="searchOptionsSignal.options" item-text="text" item-value="abbr" class="form-select ml-3" outlined
                dense hide-details clearable></v-select>
            <v-btn @click="() => {this.selected=[];togetPowerRailList(1)}" class="btn type-search ml-3" text>
                {{ $t('Search') }}
            </v-btn>
     </div>
        <div class="col-12 pl-0 pb-0 pt-0 pr-0 d-flex" style="margin-top:10px">
            <div class="col-12 pl-0">
                <v-data-table v-model="selected" :headers="PowerRailInfoHeaders"
                    :hide-default-footer="true" :items="powerrails"
                    :options.sync="options" show-select :server-items-length="totalpowerrails" class="tbl-type01 mt-10"
                    item-key="code">
                    <!-- No Data Slot -->
                    <template slot="no-data">
                        <p>
                            {{ $t('No data available') }}
                        </p>
                    </template>
                    <!-- Network Status Slot -->
                    <template v-slot:[`item.assignedLabelCount`]="{ item }">
                        <p>
                          <i @click="GetLabelInfo(item)" style="cursor: pointer;">
                           <img src="@/assets/img/info-ico-custom.png" alt="" height="25" />
                          </i>
                        </p>
                    </template>
                      <!-- Connectivity state Slot -->
                    <template v-slot:[`item.status`]="{ item }">
                      <v-tooltip top content-class="tooltip-content">
                        <template v-slot:activator="{ on, attrs }">
                          <div v-bind="attrs" v-on="on">
                            <div class="d-flex justify-center" v-if="item.status !== '-'">
                              <p  class="circle"  :style="item.status && item.status.toLowerCase() === 'offline'.toLowerCase() ? 'background-color: #e27070' : 'background-color: #9bcde3' " ></p>
                            </div>
                            <div v-else>{{ item.status }}</div>
                          </div>
                        </template>
                        <span>{{ $t(item.status) }}</span>
                      </v-tooltip>
                    </template>
                    <template v-slot:[`item.shelfInfo`]="{ item }">
                      <div class="d-flex justify-center" v-if="item.status !== '-'">
                        <v-tooltip top content-class="tooltip-content">
                          <template v-slot:activator="{ on, attrs }">
                            <div v-bind="attrs" v-on="on"> {{ item.shelfId ? item.shelfId : '-'  }} </div>
                          </template>
                          <span>{{ $t('Shelf Id') }}</span>
                        </v-tooltip>
                        <div class="ml-1 mr-1">{{ " / " }}</div>
                        <v-tooltip top content-class="tooltip-content">
                          <template v-slot:activator="{ on, attrs }">
                            <div v-bind="attrs" v-on="on"> {{ item.shelfFloor ? item.shelfFloor : '-' }} </div>
                          </template>
                          <span>{{ $t('Shelf Floor') }}</span>
                        </v-tooltip>
                        <div class="ml-1 mr-1">{{ " / " }}</div>
                        <v-tooltip top content-class="tooltip-content">
                          <template v-slot:activator="{ on, attrs }">
                            <div v-bind="attrs" v-on="on"> {{ item.shelfRow ? item.shelfRow : '-'}} </div>
                          </template>
                          <span>{{ $t('Shelf Row')}}</span>
                        </v-tooltip>
                      </div>
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
          <div class="d-flex">
            <p @click.stop="!['UNASSIGNED', 'UNASSIGNING'].includes(item.state) && editDialogOpen(item)" class="d-inline-block mr-2"
               :class="{ 'disabled-pointer': ['UNASSIGNED', 'UNASSIGNING'].includes(item.state), 'pointer': !['UNASSIGNED', 'UNASSIGNING'].includes(item.state) }"
             >
          <v-icon size="24" class="darken-2" :style="{ color: ['UNASSIGNED', 'UNASSIGNING'].includes(item.state) ? '#A0A0A0' : '#001e38' }">
                mdi-square-edit-outline
          </v-icon>
            </p>

          </div>
        </template>
                </v-data-table>
            </div>
        </div>
        <PowerRailLabelDetailModel v-model="LabelDetailsPopup" :powerRailCode="powerRailCode" :ControllerID="ControllerID"  />
        <div class="table-options">
            <div>
                <v-btn :disabled="selected.length !==1 || isAssignUnassignDeleteDisabled" @click="assignPowerRailPopup()" class="btn ml-2" text>{{
                    $t('Assign') }}
                </v-btn>
                <v-btn :disabled="selected.length===0 || isAssignUnassignDeleteDisabled" @click="UnlinkPowerRail()"  class="btn ml-2" text>{{
                    $t('Unassign') }}
                </v-btn>
                <v-btn :disabled="selected.length===0 || isAssignUnassignDeleteDisabled" @click="DeletePowerRail()"  class="btn ml-2" text>{{
                    $t('Delete') }}
                </v-btn>
                <v-btn :disabled="selected.length===0 || isAssignUnassignDeleteDisabled" @click="ResetPowerRail()"  class="btn ml-2" text>{{
                    $t('Reset') }}
                </v-btn>

            </div>
        </div>
        <!-- Pagination Component -->
        <Pagination @paging="paging($event)" :pageInfoText="pageInfoText" :pageIndex="pageIndex"
            :rowPerPage="rowPerPage" :goToPageInput="goToPageInput" :totalPages="totalPages"
            @updatePage="updatePage($event)"></Pagination>
        <!-- Hidden Link Element for Exporting -->
        <a ref="link" :style="{ display: 'none' }" />
        <!-- Message Box Component -->
        <msg-box :msgBox="msgBox" @closeMsgBox="closeMsgBox" />

 <!-- assignPopup -->
 <v-dialog v-model="assignPopup" persistent scrollable width="450">
      <v-card class="popup add_store_popup">
        <v-card-title>
          <h3 class="page-title-bar">
            <i class="ico ico-multi"></i>{{ $t("ASSIGN") }}
          </h3>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="assignPowerRailData.powerRailId"
            outlined
            dense
            hide-details
            disabled
            :placeholder="`${$t('Input Power Rail ID')}`"
            class="form-input mb-2"
            :label="$t('Power Rail ID *')"
          >
          </v-text-field>
          <v-text-field
            v-model="assignPowerRailData.shelfId"
            outlined
            dense
            hide-details
            :placeholder="`${$t('Input Shelf ID')}`"
            class="form-input mb-2"
            :label="$t('Shelf ID')"
          >
          </v-text-field>
          <v-text-field
            v-model="assignPowerRailData.shelfFloor"
            outlined
            dense
            hide-details
            :placeholder="`${$t('Input Shelf Floor')}`"
            class="form-input mb-2"
            :label="$t('Shelf Floor')"
          >
          </v-text-field>
          <v-text-field
            v-model="assignPowerRailData.shelfRow"
            outlined
            dense
            hide-details
            :placeholder="`${$t('Input Shelf Row')}`"
            class="form-input mb-2"
            :label="$t('Shelf Row')"
          >
          </v-text-field>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <v-btn
          v-if="!editPopup"
            @click="assignPowerRail()"
            text
            icon
            class="btn"
            :disabled="assignPowerRailData.powerRailId ===null || assignPowerRailData.powerRailId === ''"
            >{{ $t("Assign") }}
          </v-btn>
          <v-btn
          v-if="editPopup"
            @click="UpdatePowerRail()"
            text
            icon
            class="btn"
            :disabled="assignPowerRailData.powerRailId ===null || assignPowerRailData.powerRailId === ''"
            >{{ $t("Update") }}
          </v-btn>

          <v-btn @click="assignPopup=false;editPopup=false" class="btn" text icon
            >{{ $t("Cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    </div>
</template>

<script>
// libraries
import { mapGetters } from 'vuex'
// mixins
import MsgBoxParent from '@/mixins/MsgBoxParent'
// utils
import EventBus from '@/plugins/eventBus'
import codes from '@/plugins/codes'
// components
import PowerRailLabelDetailModel from './model/PowerRailLabelDetailModel.vue'
import commons from '@/plugins/commons'
import Pagenation from '@/mixins/Pagenation'
import Pagination from '@/components/pagination/Pagination.vue'
// Importing CSS
import '@/assets/css/freeze.css'

export default {
  name: 'GatewayInfo',
  mixins: [MsgBoxParent, Pagenation],
  components: {
    PowerRailLabelDetailModel,
    Pagination
  },
  data () {
    return {
      user: null,
      isAssignUnassignDeleteDisabled: false,
      page: 1,
      pageIndex: 1,
      rowPerPage: '10',
      totalPages: 0,
      totalpowerrails: null,
      options: {},
      pageInfoText: '',
      selected: [],
      // search: {
      //   code: null,
      //   state: null,
      //   sort: 'code,asc'
      // },
      powerrails: [],
      ROW_CLASS: 'row-class',
      assignPopup: false,
      LabelDetailsPopup: false,
      ControllerID: null,
      powerRailCode: null,
      assignPowerRailData: {
        powerRailId: '',
        shelfFloor: '',
        shelfId: '',
        shelfRow: ''
      },
      editPopup: false,
      search: {
        type: 'powerRail',
        code: null,
        state: null,
        shelfId: null,
        shelfFloor: null,
        shelfRow: null,
        battery: null,
        signal: null,
        sort: 'code,asc'
      },
      searchTypes: [
        { text: 'POWER RAIL ID / STATUS', value: 'powerRail' },
        { text: 'SHELF', value: 'shelf' },
        { text: 'BATTERY', value: 'battery' },
        { text: 'SIGNAL', value: 'signal' }
      ]
    }
  },
  computed: {
    PowerRailInfoHeaders () {
      return [
        {
          text: this.$t('POWER RAIL ID'),
          value: 'code',
          align: 'left',
          width: '10%',
          disabled: true,
          sortable: true
        },
        // {
        //   text: this.$t('POWER RAIL MAC'),
        //   value: 'macAddress',
        //   align: 'left',
        //   width: '10%',
        //   disabled: false,
        //   sortable: true
        // },
        {
          text: this.$t('CONNECTED GATEWAY'),
          value: 'connectedGw',
          align: 'left',
          width: '12%',
          disabled: false,
          sortable: true
        },
        {
          text: this.$t('TYPE'),
          value: 'type',
          align: 'left',
          width: '12%',
          disabled: false,
          sortable: true
        },
        {
          text: this.$t('SHELF INFO'),
          value: 'shelfInfo',
          align: 'left',
          width: '12%',
          disabled: false,
          sortable: true
        },
        {
          text: this.$t('BATTERY'),
          value: 'battery',
          align: 'left',
          width: '10%',
          disabled: false,
          sortable: false
        },
        {
          text: this.$t('SIGNAL'),
          value: 'signal',
          align: 'left',
          width: '10%',
          disabled: false,
          sortable: false
        },
        {
          text: this.$t('FW VERSION'),
          value: 'fwversion',
          align: 'left',
          width: '10%',
          disabled: false,
          sortable: false
        },
        {
          text: this.$t('CONNECTIVITY'),
          value: 'status',
          align: 'center',
          width: '10%',
          disabled: false,
          sortable: false
        },
        {
          text: this.$t('STATUS'),
          align: 'left',
          value: 'state',
          width: '10%',
          sortable: true,
          disabled: true
        },
        {
          text: this.$t('LABELS'),
          value: 'assignedLabelCount',
          disabled: true,
          align: 'center',
          width: '10%',
          sortable: false
        },

        {
          text: this.$t('LAST CONNECTION TIME'),
          align: 'left',
          value: 'statusUpdateTime',
          width: '10%',
          sortable: true,
          disabled: true
        },
        {
          text: '',
          align: 'center',
          sortable: false,
          value: 'action'
        }

      ]
    },
    searchOptions () {
      return {
        network: [
          { text: this.$t('PROCESSING'), abbr: 'PROCESSING' },
          { text: this.$t('SUCCESS'), abbr: 'SUCCESS' },
          { text: this.$t('TIMEOUT'), abbr: 'TIMEOUT' },
          { text: this.$t('UNASSIGNING'), abbr: 'UNASSIGNING' },
          { text: this.$t('UNASSIGNED'), abbr: 'UNASSIGNED' }

        ]
      }
    },
    searchOptionsBattery () {
      return {
        options: [
          { text: this.$t('GOOD'), abbr: 'GOOD' },
          { text: this.$t('BAD'), abbr: 'BAD' }
        ]
      }
    },
    searchOptionsSignal () {
      return {
        options: [
          { text: this.$t('EXCELLENT'), abbr: 'EXCELLENT' },
          { text: this.$t('GOOD'), abbr: 'GOOD' },
          { text: this.$t('BAD'), abbr: 'BAD' }
        ]
      }
    },
    selectedStore () {
      return this.$store.getters['dataStore/GET_SELECTED_STORE'].code
    },
    ...mapGetters({
      store: 'dataStore/GET_SELECTED_STORE'
    })
  },
  watch: {
    options: function () {
      if (this.store.code !== '') {
        this.togetPowerRailList(this.page)
      }
    },
    pageIndex: {
      handler (page) {
        this.goToPageInput = page
      }
    },
    store: {
      handler () {
        this.options.itemsPerPage = Number(this.rowPerPage)
        if (this.store.code !== '') {
          this.togetPowerRailList(1)
        }
        this.page = 1
      }
    }
  },

  created () {
    // Get the user from the auth store state
    this.user = this.$store.state.auth.user
  },
  mounted () {
    this.$store.dispatch('auth/getDisabledBtn', '12100').then(flag => {
      this.isAssignUnassignDeleteDisabled = flag
    })
    EventBus.$emit('enableSelectedStores', true)
    if (
      this.store === undefined ||
      !this.store.code ||
      this.store.code === ''
    ) {
      EventBus.$emit('openSelectedStores')
    } else {
      this.togetPowerRailList(1)
    }
  },
  methods: {
    // Perform pagination by updating the gateway list for the specified page
    paging (input) {
      this.goToPageInput = input
      this.togetPowerRailList(input)
    },
    // Update the number of items per page and update the gateway list accordingly
    updatePage (event) {
      this.rowPerPage = event.toString()
      this.paging(1)
    },
    // Build the search parameters for retrieving the gateway list
    buildSearchParams (params, search) {
      if (search.state !== null) params.state = search.state
      if (!commons.isNull(search.code)) params.code = search.code
      if (!commons.isNull(search.shelfId)) params.shelfId = search.shelfId
      if (!commons.isNull(search.shelfFloor)) params.shelfFloor = search.shelfFloor
      if (!commons.isNull(search.shelfRow)) params.shelfRow = search.shelfRow
      if (!commons.isNull(search.battery)) params.battery = search.battery
      if (!commons.isNull(search.signal)) params.signal = search.signal
      return params
    },
    getPowerRailSortKey (sortKey) {
      switch (sortKey) {
        case 'statusUpdateTime': sortKey = 'statusUpdateTime'
          break
        case 'controllerId': sortKey = 'controllerId'
          break
        default: break
      }
      return sortKey
    },
    buildGetPowerRailParams () {
      // const { itemsPerPage } = this.options
      const { sortBy, sortDesc, itemsPerPage } = this.options
      let params = { store: this.store.code }
      if (itemsPerPage > 0) params.size = this.rowPerPage
      params = this.buildSearchParams(params, this.search)
      let sort = null
      if (commons.isSorting(sortBy, sortDesc)) {
        const sortKey = this.getPowerRailSortKey(sortBy[0])
        const sortOrder = sortDesc[0]
        sort = `${sortKey},${sortOrder ? 'desc' : 'asc'}`
      }
      if (sort !== null) params.sort = sort
      params.company = this.$store.state.auth.user.company
      params.store = this.store.code
      return params
    },
    getRowClass () {
      return codes.ROW_CLASS
    },
    assignPowerRailPopup () {
      this.assignPowerRailData.powerRailId = this.selected[0].code
      this.assignPowerRailData.shelfFloor = this.selected[0].shelfFloor
      this.assignPowerRailData.shelfRow = this.selected[0].shelfRow
      this.assignPowerRailData.shelfId = this.selected[0].shelfId
      this.assignPopup = true
    },
    togetPowerRailList (page) {
      const params = this.buildGetPowerRailParams()
      if (commons.isNull(params.store)) return
      if (page !== null) params.page = page - 1
      const config = { params }
      this.$utils
        .callAxios(
          codes.requests.toGetPowerRailController.method,
          codes.requests.toGetPowerRailController.url,
          config
        )
        .then(res => {
          const headers = res.headers
          if (res.status === 200) {
            this.powerrails = (res?.data?.powerRails ?? []).map((obj, idx) => {
              return {
                serialNo: headers['x-number'] * 1 * headers['x-size'] + idx + 1,
                ...obj,
                statusUpdateTime: commons.convertDate(obj.statusUpdateTime),
                macAddress: obj.macAddress ? obj.macAddress.split('_').join(' ') : obj.macAddress
              }
            })
            this.totalpowerrails = this.powerrails.length
            // Pagination
            this.pageInfoText = this.getPageInfoText(res.headers)
            if (commons.isValidStr(res.headers['x-totalpages'])) {
              this.totalPages = res.headers['x-totalpages'] * 1
            }
            this.page = page
            this.pageIndex = res.headers['x-number'] * 1 + 1
          } else {
            this.powerrails = []
          }
        })
        .catch(error => {
          console.log(error)
          this.powerrails = []
          EventBus.$emit(
            'messageAlert',
            this.$t(error.response.data.returnMsg),
            'error'
          )
        })
    },
    // toGetPowerRailController

    getPageInfoText: function (headers) {
      if (headers['x-totalelements'] === 0) return '0 to 0, 0' + ' ' + this.$t('in total')
      return `${headers['x-number'] * 1 * headers['x-size'] + 1}
      ${this.$t('to')} ${(headers['x-number'] * 1 * headers['x-size']) + headers['x-total-count'] * 1},
       ${headers['x-totalelements'] * 1}` + ' ' + this.$t('in total')
    },
    GetLabelInfo (value) {
      this.ControllerID = value.controllerId
      this.powerRailCode = value.code
      this.LabelDetailsPopup = true
    },
    assignPowerRail () {
      const body = this.assignPowerRailData
      const params = {
        company: this.$store.state.auth.user.company,
        store: this.store.code,
        powerRailCode: this.assignPowerRailData.powerRailId
      }
      const config = { params }
      this.$utils
        .callAxiosWithBody(
          codes.requests.toAssignPowerRail.method,
          codes.requests.toAssignPowerRail.url + '/' + this.store.code,
          body,
          config
        )
        .then(res => {
          if (res.status === 200) {
            EventBus.$emit('messageAlert', this.$t(res.data.returnMsg))
            this.assignPopup = false
            this.selected = []
            this.paging(1)
          }
        })
        .catch(error => {
          console.log(error)
          EventBus.$emit(
            'messageAlert',
            this.$t(error.response.data.returnMsg),
            'error'
          )
          this.assignPopup = false
        })
    },
    UnlinkPowerRail () {
      const config = {
        params: {
          company: this.$store.state.auth.user.company,
          store: this.selectedStore
        },
        data: this.selected.map((s) => (s.code))
      }
      this.$utils
        .callAxios(
          codes.requests.unassignMultiPowerRail.method,
          codes.requests.unassignMultiPowerRail.url,
          config
        )
        .then(res => {
          if (res.status === 200) {
            this.selected = []
            EventBus.$emit('messageAlert', this.$t(res.data.returnMsg))
            this.paging(1)
          } else {
            EventBus.$emit('messageAlert', this.$t('Something went wrong. Please try after some time.'))
          }
        })
        .catch(error => {
          console.error('error', error.response.data)
          EventBus.$emit('messageAlert', this.$t('Unassign Failed'))
        })
    },
    editDialogOpen (item) {
      if (!this.isAssignUnassignDeleteDisabled) {
        this.assignPowerRailData.powerRailId = item.code
        this.assignPowerRailData.shelfFloor = item.shelfFloor
        this.assignPowerRailData.shelfRow = item.shelfRow
        this.assignPowerRailData.shelfId = item.shelfId
        this.assignPopup = true
        this.editPopup = true
      }
    },
    UpdatePowerRail () {
      const body = this.assignPowerRailData
      const params = {
        company: this.$store.state.auth.user.company,
        store: this.store.code,
        powerRailCode: this.assignPowerRailData.powerRailId
      }
      const config = { params }
      this.$utils
        .callAxiosWithBody(
          codes.requests.toUpdatePowerRailShelf.method,
          codes.requests.toUpdatePowerRailShelf.url,
          body,
          config
        )
        .then(res => {
          if (res.status === 200) {
            EventBus.$emit('messageAlert', this.$t(res.data.returnMsg))
            this.assignPopup = false
            this.editPopup = false
            this.selected = []
            this.paging(1)
          }
        })
        .catch(error => {
          console.log(error)
          EventBus.$emit(
            'messageAlert',
            this.$t(error.response.data.returnMsg),
            'error'
          )
          this.assignPopup = false
          this.editPopup = false
        })
    },
    async DeletePowerRail () {
      const ok = await this.$confirm.open({
        title: 'Delete Confirmation',
        message: 'Are you sure you want to delete selected power rail?'
      })
      if (!ok) return
      const config = {
        params: {
          company: this.$store.state.auth.user.company,
          store: this.selectedStore
        },
        data: this.selected.map((s) => (s.code))
      }
      this.$utils
        .callAxios(
          codes.requests.deleteMultiplePowerRail.method,
          codes.requests.deleteMultiplePowerRail.url,
          config
        )
        .then(res => {
          if (res.status === 200) {
            this.selected = []
            EventBus.$emit('messageAlert', this.$t(res.data.returnMsg))
            this.paging(1)
          } else {
            EventBus.$emit('messageAlert', this.$t('Something went wrong. Please try after some time.'))
          }
        })
        .catch((error) => {
          console.error('error', error.response.data)
          EventBus.$emit('messageAlert', this.$t('Delete Failed.'))
        })
    },
    ResetPowerRail () {
      const config = {
        params: {
          company: this.$store.state.auth.user.company,
          store: this.selectedStore
        }

      }
      const body = this.selected.map((s) => (s.code))

      console.log(config)
      this.$utils
        .callAxiosWithBody(
          codes.requests.resetPowerRail.method,
          codes.requests.resetPowerRail.url,
          body,
          config
        )
        .then(res => {
          if (res.status === 200) {
            this.selected = []
            EventBus.$emit('messageAlert', this.$t(res.data.returnMsg))
            this.paging(1)
          } else {
            EventBus.$emit('messageAlert', this.$t('Something went wrong. Please try after some time.'))
          }
        })
        .catch((error) => {
          console.error('error', error.response.data)
          EventBus.$emit('messageAlert', this.$t('Reset Failed.'))
        })
    },
    InputReset () {
      this.search.code = null
      this.search.state = null
      this.search.shelfId = null
      this.search.shelfFloor = null
      this.search.shelfRow = null
      this.search.battery = null
      this.search.signal = null
    }
  }

}
</script>

<style >
  .tooltip-content {
    background: #001E38;
    color: #fff;
  }
  .disabled-pointer {
  pointer-events: none;
  opacity: 0.5;
}

.pointer {
  cursor: pointer;
}

</style>

<style scoped>
.hidden {
    display: none;
}

.pageAlign {
    float: right;

}
.circle {
  height: 15px;
  width: 15px;
  border-radius: 50%;
}
</style>
